export default __webpack_public_path__ + "static/precoDeVenda1-8429f1f98c47150b187b6fc7594c7995.jpeg";